import { apiSlice } from "./apiSlice";
import { GradeEntity } from "../../services/grade/grade.types";

/**
 * Grades are a small full-list catalog (no server-side pagination), so a
 * single list query is enough; the table behaves client-side as before.
 */
export const gradesApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getGrades: builder.query<GradeEntity[], void>({
      query: () => ({
        url: "/grades",
        method: "GET",
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ id }) => ({ type: "Grade" as const, id })),
              { type: "Grade" as const, id: "LIST" },
            ]
          : [{ type: "Grade" as const, id: "LIST" }],
    }),
    deleteGrade: builder.mutation<void, number>({
      query: (id) => ({
        url: `/grades/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [{ type: "Grade", id: "LIST" }],
    }),
  }),
});

export const { useGetGradesQuery, useDeleteGradeMutation } = gradesApi;
